import axios from "axios"
import { drawId, Token } from "../urlParams"
import { REACT_APP_USER_API_URL } from "../../envVariables"
export interface drawDetailsProps {
  draw:{
    drawDetails:any
    drawTime:string
    cutoffTime:string
    prizes:patternTypes
    status:number
    id:string
    game:{
      id:string
      maxNumberRange:number
      name:string
      gridSize:string
    },
    settlementType:string
  }
}
type Pattern = [number, number][];
interface PatternDetails {
  price: number;
  pattern: Pattern[]; 
  winCount: number;
  patternClaimCount: number;
}
type patternTypes={
  [key: string]: PatternDetails
}

export const getDrawDetail=async()=>{
    try{
      const response=await axios.get(`${REACT_APP_USER_API_URL}lottery/draw-detail?drawId=${drawId}`,{
        headers:{
          'Authorization':`AccessToken=${Token}` 
        }
      })
    //   globalData.drawDetails=response.data
    //   globalData.winningPatterns=response.data.data.draw.prizes
    //   globalData.drawNumbers=response.data.data.draw.drawDetails
    //   globalData.maxNumberRange=response.data.data.draw.game.maxNumberRange
    //   globalData.drawTime=response.data.data.draw.drawTime
    //   console.log(globalData.maxNumberRange,"sdfffffffffffff")
      return response.data.data
    }catch(error){
    }
    }

    export const DemogetDrawDetail=async()=>{
      try{
        const response=await axios.get(`${REACT_APP_USER_API_URL}lottery/draw-detail?drawId=${drawId}`,{
        
        })
      //   globalData.drawDetails=response.data
      //   globalData.winningPatterns=response.data.data.draw.prizes
      //   globalData.drawNumbers=response.data.data.draw.drawDetails
      //   globalData.maxNumberRange=response.data.data.draw.game.maxNumberRange
      //   globalData.drawTime=response.data.data.draw.drawTime
      //   console.log(globalData.maxNumberRange,"sdfffffffffffff")
        return response.data.data
      }catch(error){
      }
      }
    